export { default as HospitalSystems } from './HospitalSystems';
